import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getCropFootprintByCropIdAndYear } from "services";

import { useGetCarbonProgramByFarmId } from "utils";

import { FOOTPRINTING_CROP } from "consts";

export const useGetFootprintingCropFootprint = (farmId?: string, cropId?: string, year?: number, { enabled = true } = {}) => {
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);

  const enableQuery = (enabled && !!farmId && !!cropId && !!year && carbonProgram?.platformFeatures?.footprinting?.enabled) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_CROP, farmId, cropId, year],
      queryFn: () => getCropFootprintByCropIdAndYear(cropId ?? "", year ?? 0),
      enabled: enableQuery,
      gcTime: 60000,
    },
    queryClient
  );
};
